import React from 'react';
import { useAuthStore } from '../store/useAuthStore';
import ProtestList from '../components/ProtestList';
import StatsDashboard from '../components/StatsDashboard';
import ProtestMap from '../components/ProtestMap';
import styles from './Dashboard.module.css';

export default function Dashboard() {
    const user = useAuthStore((s) => s.user);

    return (
        <div className={`${styles.page} text-ar`}>
            <div className={styles.pageHeader}>
                <h1>التظاهرات</h1>
                <p className={styles.subtitle}>مرحباً، {user?.name}</p>
            </div>

            {user?.role === 'super_admin' && <StatsDashboard />}
            {user?.role === 'super_admin' && <ProtestMap />}

            <ProtestList />
        </div>
    );
}
